import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const LoadingOverlay = () => {
  return (
    <div
      role='status'
      aria-label='Loading data'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(245, 247, 246, 0.7)', // Light gray with opacity
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      <LoadingSpinner />
    </div>
  );
};

export default LoadingOverlay;
